import React, { useEffect, useState } from 'react';

const ViewSwitcher = ({ MobileLayout, DesktopLayout }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setShouldRender(true);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);

    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (!shouldRender) {
    return null;
  }
  console.log('View Switcher', isMobile)

  return isMobile ? <MobileLayout /> : <DesktopLayout />;
};

export { ViewSwitcher };
